import * as swcHelpers from '@swc/helpers';
import { dispatchTrackErrorEvent } from '@grandvisionhq/svc-tealium/events';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/set-store.js';
import '../../operations/mutations/create-apple-pay-session.js';
import { RECREATE_ORDERED_CHECKOUT } from '../../operations/mutations/recreate-ordered-checkout.js';

function recoverCheckout(apolloClient, checkoutId) {
    return _recoverCheckout.apply(this, arguments);
}
function _recoverCheckout() {
    _recoverCheckout = swcHelpers.asyncToGenerator(function*(apolloClient, checkoutId) {
        const { data , errors  } = yield apolloClient.mutate({
            mutation: RECREATE_ORDERED_CHECKOUT,
            variables: {
                orderedCheckoutInput: {
                    checkoutId
                }
            }
        });
        if (errors) {
            errors.forEach((error)=>console.error('recoverCheckout:', error)
            );
            dispatchTrackErrorEvent(()=>Promise.resolve({
                    Error_Source: 'Server',
                    Error_Code: 'Recover checkout error',
                    Error_Details: errors.map((error)=>error.message
                    ).join(',')
                })
            );
            throw new Error('Failed to recover checkout');
        }
        const responseData = data === null || data === void 0 ? void 0 : data.recreateOrderedCheckout;
        return responseData ? {
            success: responseData === null || responseData === void 0 ? void 0 : responseData.success,
            cartId: responseData === null || responseData === void 0 ? void 0 : responseData.newCheckoutId,
            cartHash: responseData === null || responseData === void 0 ? void 0 : responseData.checkoutHash
        } : {
            success: false
        };
    });
    return _recoverCheckout.apply(this, arguments);
}

export { recoverCheckout };
//# sourceMappingURL=recover-checkout.js.map
